import moment from 'moment';

import FormEdit from './steps/FormEdit.vue';

import { AddDialogAttributes, InstallerCapacity } from '@/types';

import WithSteps from '@/apps/office/containers/table/shared/dialogs/with-steps';

type FormData = {
  item: {
    housingCooperativeId: number;
    target: number;
    year: number;
  };
  formValid: boolean;
};

export default WithSteps<FormData, AddDialogAttributes>({
  title: 'office.dialogs.installations.targets.edit.title',

  maxWidth: 600,

  formData() {
    const now = moment();

    return {
      item: {
        housingCooperativeId: +this.$store.state.route.params.id,
        target: 0,
        year: now.get('year'),
      },

      formValid: false,
    };
  },

  steps: [
    {
      component: FormEdit,

      isValid() {
        return this.$data.formValid;
      },

      props() {
        return {
          item: this.$data.item,
        };
      },

      value: {
        get() {
          return this.$data.formValid;
        },

        set(isValid: boolean) {
          this.$data.formValid = isValid;
        },
      },

      labels: {
        action: 'dialogs.save',
      },

      async afterStep() {
        await this.$store.dispatch('planning/targets/item:create', {
          item: this.$data.item,
        });

        this.$store.dispatch('planning/targets/settings/search');
      },
    },
  ],
});
